(() => {
  'use strict';
  if (window.__premierNavigationTracking) return;
  window.__premierNavigationTracking = true;
  const measurementId = 'G-3JGML5ZLZK';
  const pendingKey = 'premier_navigation_click';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  const label = element => clean(element && (element.textContent || element.getAttribute('aria-label')));
  function publish(name, data) {
    if (!allowed()) return;
    const payload = { ...data, source_path: data.source_path || location.pathname };
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      try {
        Promise.resolve(window.Shopify.analytics.publish(name, payload)).catch(() => {});
      } catch (_) {}
    }
    if (typeof window.gtag !== 'function') return;
    const googleName = {
      premier_navigation_click: 'navigation_click',
      premier_navigation_open: 'navigation_open',
      premier_navigation_submenu_open: 'navigation_submenu_open'
    }[name];
    if (!googleName) return;
    try {
      window.gtag('event', googleName, {
        ...payload,
        send_to: measurementId,
        ...(window.__premierNavigationDebugMode === true ? { debug_mode: true } : {})
      });
    } catch (_) {}
  }
  function clearPending() {
    try { window.sessionStorage.removeItem(pendingKey); } catch (_) {}
  }
  let pendingAttempts = 0;
  function flushPending() {
    let pending;
    try { pending = JSON.parse(window.sessionStorage.getItem(pendingKey) || 'null'); }
    catch (_) { clearPending(); return; }
    if (!pending) return;
    let referrer;
    try { referrer = new URL(document.referrer); } catch (_) { clearPending(); return; }
    if (!Number.isFinite(pending.created) || Date.now() - pending.created > 120000 ||
        pending.created > Date.now() || pending.data?.link_path !== location.pathname ||
        referrer.origin !== location.origin || referrer.pathname !== pending.data?.source_path) {
      clearPending();
      return;
    }
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed === 'function' && !allowed()) {
      clearPending();
      return;
    }
    if (allowed() && typeof window.gtag === 'function') {
      clearPending();
      publish('premier_navigation_click', pending.data);
      return;
    }
    if (++pendingAttempts < 40) setTimeout(flushPending, 500);
    else clearPending();
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) clearPending();
  });
  flushPending();
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || !(event.target instanceof Element) || !allowed()) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const desktop = anchor.closest('mega-menu');
    const drawer = anchor.closest('.menu-drawer__navigation');
    const breadcrumb = anchor.closest('.fdl-breadcrumbs__list');
    const tileGroup = anchor.closest('.collection-links, .collection-list, [data-collection-tiles]');
    const tile = !desktop && !drawer && !breadcrumb && anchor.closest('main') && tileGroup;
    if (!desktop && !drawer && !breadcrumb && !tile) return;
    const raw = anchor.getAttribute('href');
    if (!raw || raw.startsWith('#')) return;
    let target;
    try { target = new URL(raw, location.href); } catch (_) { return; }
    if (target.origin !== location.origin) return;
    if (tile && !/^\/collections\/[^/]+\/?$/.test(target.pathname)) return;
    let group = '', subgroup = '', depth = 1, column = '';
    if (desktop) {
      const panel = anchor.closest('[data-sub-menu]');
      if (panel) {
        const heading = Array.from(desktop.querySelectorAll('[data-index]'))
          .find(el => el.getAttribute('data-index') === panel.getAttribute('data-main'));
        group = label(heading);
        const wrapper = anchor.closest('.flex.flex-col');
        const parentLink = wrapper?.querySelector('a');
        subgroup = parentLink && parentLink !== anchor ? label(parentLink) : '';
        depth = subgroup ? 3 : 2;
        const col = anchor.closest('[class*="col-"]');
        column = Array.from(col?.classList || []).find(c => /^col-[1-6]$/.test(c)) || '';
      } else group = label(anchor);
    } else if (drawer) {
      const sections = [];
      let current = anchor.parentElement;
      while (current && current !== drawer) {
        if (current.tagName === 'DETAILS') {
          const summary = Array.from(current.children).find(el => el.tagName === 'SUMMARY');
          if (summary) sections.unshift(label(summary));
        }
        current = current.parentElement;
      }
      group = sections[0] || label(anchor);
      subgroup = sections[1] || '';
      depth = sections.length + 1;
    } else if (breadcrumb) {
      const items = Array.from(breadcrumb.querySelectorAll('.fdl-breadcrumbs__item'));
      depth = items.indexOf(anchor.closest('.fdl-breadcrumbs__item')) + 1;
    }
    const data = {
      navigation_location: breadcrumb ? 'breadcrumb' : drawer ? 'drawer_menu' : desktop ? 'desktop_menu' : 'collection_tile',
      link_text: label(anchor) || clean(anchor.querySelector('img')?.alt) || target.pathname,
      link_path: target.pathname,
      source_path: location.pathname,
      menu_group: group,
      menu_subgroup: subgroup,
      menu_depth: depth,
      menu_column: column,
      ...(tile ? {
        tile_position: Array.from(tileGroup.querySelectorAll('a[href]'))
          .filter(el => {
            try {
              const url = new URL(el.getAttribute('href'), location.href);
              return url.origin === location.origin && /^\/collections\/[^/]+\/?$/.test(url.pathname);
            } catch (_) { return false; }
          }).indexOf(anchor) + 1,
        tile_section: clean(tileGroup.closest('.shopify-section')?.id || tileGroup.id || 'collection_tiles')
      } : {})
    };
    const linkTarget = (anchor.getAttribute('target') || document.querySelector('base[target]')?.getAttribute('target') || '_self').toLowerCase();
    const fragmentOnly = target.pathname === location.pathname && target.search === location.search && !!target.hash;
    const sameTab = event.cancelable && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey &&
      linkTarget === '_self' && !anchor.hasAttribute('download') && !fragmentOnly;
    if (sameTab) {
      try {
        window.sessionStorage.setItem(pendingKey, JSON.stringify({ created: Date.now(), data }));
        return;
      } catch (_) {}
    }
    publish('premier_navigation_click', data);
  }, true);
  // Element IDs can repeat in the drawer; track state by element identity.
  const openStates = new WeakMap();
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    const isDrawer = details.id === 'Details-menu-drawer-container';
    if (!isDrawer && !details.closest('.menu-drawer__navigation')) return;
    const wasOpen = openStates.get(details) === true;
    openStates.set(details, details.open);
    if (!details.open || wasOpen) return;
    if (details.id === 'Details-menu-drawer-container') {
      publish('premier_navigation_open', { navigation_location: 'drawer_menu', menu_group: 'main' });
    } else {
      const summary = Array.from(details.children).find(el => el.tagName === 'SUMMARY');
      publish('premier_navigation_submenu_open', { navigation_location: 'drawer_menu', menu_group: label(summary) });
    }
  }, true);
})();
